var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01814 5.66406C7.84585 5.66406 8.51685 6.33505 8.51685 7.16277V47.6278H48.9818C49.8095 47.6278 50.4805 48.2987 50.4805 49.1265C50.4805 49.9542 49.8095 50.6252 48.9818 50.6252H8.51685C7.72189 50.6252 6.95948 50.3094 6.39736 49.7472C5.83524 49.1851 5.51944 48.4227 5.51944 47.6278V7.16277C5.51944 6.33505 6.19043 5.66406 7.01814 5.66406Z",
    fill: "#2D6772"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8865 26.6458C14.6796 26.6458 14.5118 26.8136 14.5118 27.0205V41.2582C14.5118 41.4651 14.6796 41.6329 14.8865 41.6329H18.6333C18.8402 41.6329 19.008 41.4651 19.008 41.2582V27.0205C19.008 26.8136 18.8402 26.6458 18.6333 26.6458H14.8865ZM11.5144 27.0205C11.5144 25.1582 13.0242 23.6484 14.8865 23.6484H18.6333C20.4956 23.6484 22.0054 25.1582 22.0054 27.0205V41.2582C22.0054 43.1205 20.4956 44.6303 18.6333 44.6303H14.8865C13.0242 44.6303 11.5144 43.1205 11.5144 41.2582V27.0205Z",
    fill: "#2D6772"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3749 22.1498C28.1679 22.1498 28.0002 22.3175 28.0002 22.5244V41.2582C28.0002 41.4651 28.1679 41.6329 28.3749 41.6329H32.1216C32.3285 41.6329 32.4963 41.4651 32.4963 41.2582V22.5244C32.4963 22.3175 32.3285 22.1498 32.1216 22.1498H28.3749ZM25.0028 22.5244C25.0028 20.6621 26.5125 19.1523 28.3749 19.1523H32.1216C33.984 19.1523 35.4937 20.6621 35.4937 22.5244V41.2582C35.4937 43.1206 33.984 44.6303 32.1216 44.6303H28.3749C26.5125 44.6303 25.0028 43.1206 25.0028 41.2582V22.5244Z",
    fill: "#2D6772"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8291 16.1551C41.6222 16.1551 41.4545 16.3229 41.4545 16.5298V41.2584C41.4545 41.4653 41.6222 41.6331 41.8291 41.6331H45.5759C45.7828 41.6331 45.9506 41.4653 45.9506 41.2584V16.5298C45.9506 16.3229 45.7828 16.1551 45.5759 16.1551H41.8291ZM38.4571 16.5298C38.4571 14.6674 39.9668 13.1577 41.8291 13.1577H45.5759C47.4383 13.1577 48.948 14.6674 48.948 16.5298V41.2584C48.948 43.1208 47.4383 44.6305 45.5759 44.6305H41.8291C39.9668 44.6305 38.4571 43.1208 38.4571 41.2584V16.5298Z",
    fill: "#2D6772"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.249fb0d9d6f9e098e34dfd63d0b82c2a.svg";
export { ForwardRef as ReactComponent };